import tdrSolutionLogo from "../assets/tdr-solution-logo-transparent.png";

export interface BrandingConfig {
  brandName: string;
  browserTitle: string;
  landingSubtitle?: string;
  logoSrc: string | null;
  logoAlt: string;
  logoDisplay: "full" | "icon";
}

function getHostname(): string {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

export function getBranding(): BrandingConfig {
  const hostname = getHostname();
  const isTdrDomain = hostname.includes("tdrsolution-crm.com");

  if (isTdrDomain) {
    return {
      brandName: "TDR SOLUTION",
      browserTitle: "TDR SOLUTION",
      landingSubtitle: "SOLUTIONS D’INSTALLATION ENERGETIQUES ET TECHNIQUES POUR PROFESSIONNELS",
      logoSrc: tdrSolutionLogo,
      logoAlt: "Logo TDR Solution",
      logoDisplay: "full",
    };
  }

  return {
    brandName: "RegiConnect",
    browserTitle: "Regie Connect",
    logoSrc: null,
    logoAlt: "Logo RegiConnect",
    logoDisplay: "icon",
  };
}
